
export enum SchedulingMode {
  Unknown = 'Unknown',
  Calendar = 'Calendar',
  Pool = 'Pool',
  Advert = 'Advert',
}
